(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumDefaultMessageDialogController', RptCompendiumDefaultMessageDialogController);

    RptCompendiumDefaultMessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RptCompendiumDefaultMessage', 'RptLanguage', 'Compendium'];

    function RptCompendiumDefaultMessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RptCompendiumDefaultMessage, RptLanguage, Compendium) {
        var vm = this;

        vm.rptCompendiumDefaultMessage = entity;
        vm.rptLanguages = RptLanguage.query();

        Compendium.byRptCompendiumDefaultMessageDif(function (result) {
            vm.compendiums = result;

            if (vm.rptCompendiumDefaultMessage.id) {
                vm.compendiums.push(vm.rptCompendiumDefaultMessage.compendium);
            }
        });

        vm.isSaving = false;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rptCompendiumDefaultMessage.id !== null) {
                RptCompendiumDefaultMessage.update(vm.rptCompendiumDefaultMessage, onSaveSuccess, onSaveError);
            } else {
                RptCompendiumDefaultMessage.save(vm.rptCompendiumDefaultMessage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:rptCompendiumDefaultMessageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
